// Autogenerated file
export const customFieldKindsEnum = {
    ExtendedProperty: "ExtendedProperty",
    Catalog: "Catalog",
};
export const customFieldKinds = [
    { label: "Кастомное поле", value: "ExtendedProperty" },
    { label: "Справочник", value: "Catalog" },
];
